import gql from 'graphql-tag';

/**
 * Manager content for the homepage row.
 *
 * A trimmed copy of `MANAGER_CONTENT_QUERY`
 * (`src/Managers/graphql/manager-content.ts`). Item-level selections are
 * identical, so the cards get the same fields as on the managers page. Dropped:
 * the titles and summaries that page groups by, and `getAssetToken`, which the
 * shared `useAssetToken()` hook fetches once for the whole page.
 */
export const HOME_FOR_MANAGERS_QUERY = gql`
  query HomeForManagers($slug: String!) {
    exploreCategory(slug: $slug) {
      id
      subCategories {
        id
        content {
          ... on Series {
            id
            title
            slug
            subtitle
            cloudinaryThumbnail {
              path
            }
            totalDays
            daysCompleted
            exploreCategory {
              id
              title
              slug
              internalName
              colourTheme
            }
          }
          ... on Tool {
            id
            title
            summary
            slug
            estimatedMins
            cloudinaryThumbnail {
              path
            }
            mediaType {
              value
            }
            isFavourite
            exploreCategory {
              id
              slug
              colourTheme
              internalName
            }
          }
        }
      }
    }
  }
`;
